import http from "@/common/http.service";
const ROOT_URL = "templates/lists";
const IMAGE_DOMAIN_URL = "content-studio/details";
const DELETE_URL = "templates/delete";
const DETAIL_URL = "templates/get-html";
const NAME_CHECK_URL = "templates/check-name-exists";
const IMPORT_URL = "templates/process-zip";
const SAVE_URL = "templates/save";
const REMOVE_URL = "templates/remove-file";
const RENAME_URL = "templates/rename";
const DUPLICATE_URL = "templates/get-duplicate";
const DUPLICATE_LAYOUT_URL = "templates/get-duplicate-layout";
const GET_TEMPLATE_URL = "drag-and-drop/get-template";
export default {
  fetchItems(params, cb) {
    if (!params.sort_field) {
      params.sort_field = "modifiedDate";
    }
    if (!params.sort_order) {
      params.sort_order = "desc";
    }
    http.post(ROOT_URL, params).then((response) => {
      var data = {
        items: response.data.data,
        total: response.data.total,
        mcTotal: response.data.mcCount,
      };
      cb(data);
    });
  },

  fetchImageDomain(cb) {
    http.post(IMAGE_DOMAIN_URL).then((response) => {
      var data = { ...response.data };
      cb(data);
    });
  },

  delete(id) {
    return http.post(DELETE_URL, { id: id });
  },
  getDetails(params) {
    return http.post(DETAIL_URL, params);
  },
  getDragTemplate(params) {
    return http.post(GET_TEMPLATE_URL, params);
  },
  checkNameExists(params) {
    return http.post(NAME_CHECK_URL, params);
  },
  uploadFile(params) {
    return http.post(IMPORT_URL, params);
  },
  saveTemplate(params) {
    params = { ...params };
    params.html = Buffer.from(params.html).toString("base64");
    if (params.temp_json) {
      params.temp_json = Buffer.from(params.temp_json).toString("base64");
    }
    return http.post(SAVE_URL, params);
  },
  removeFile(params) {
    return http.post(REMOVE_URL, params);
  },
  rename(params) {
    return http.post(RENAME_URL, params);
  },
  duplicate(params) {
    return http.post(DUPLICATE_URL, params);
  },
  duplicateLayout(params) {
    return http.post(DUPLICATE_LAYOUT_URL, params);
  },
};
